import { render } from "./componentTitle.vue?vue&type=template&id=47c8a7ac"
import script from "./componentTitle.vue?vue&type=script&lang=js"
export * from "./componentTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__